"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.sendFeedbackMail = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../utils/HttpRequest");

var _BuildConstants = require("../utils/BuildConstants");

var sendFeedbackMail = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(to, from, cc, bcc, subject, message) {
    var token, mailUrl, data, answer;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _RegisterInstance["default"].getAccessToken('mail:send');

          case 3:
            token = _context.sent;
            mailUrl = "".concat(_BuildConstants.MAIL_HOST, "/").concat(_config["default"].feedbackEmailUrl);
            data = {
              to: to,
              subject: subject,
              message: message
            };

            if (from) {
              data['from'] = from;
            }

            if (cc) {
              data['cc'] = cc;
            }

            if (bcc) {
              data['bcc'] = bcc;
            }

            _context.next = 11;
            return (0, _HttpRequest.httpPostJsonEncoded)(mailUrl, data, null, 60000, 10, 'Bearer ' + token);

          case 11:
            answer = _context.sent;
            console.log('send mail answer', answer);
            _context.next = 19;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            console.log('error sending mail', _context.t0);
            return _context.abrupt("return", _promise["default"].reject(_context.t0));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));

  return function sendFeedbackMail(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

exports.sendFeedbackMail = sendFeedbackMail;